import { useEffect } from 'react';
import { loadScoringOverrides, writeLocalOverrides } from '@/services/scoringConfigService';
import { loadWeightOverridesFromDB } from '@/mappings/weightLoader';
import { logger } from '@/utils/structuredLogging';

// Fetches global scoring overrides from Supabase once on app start and caches them in localStorage for synchronous access
export function useScoringOverrides() {
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Load both llm_config overrides and scoring_weight_overrides
        const [configOverrides] = await Promise.all([
          loadScoringOverrides(),
          loadWeightOverridesFromDB()
        ]);
        
        if (!mounted) return;
        writeLocalOverrides(configOverrides);
      } catch (err) {
        logger.warn('useScoringOverrides: falling back to defaults', { component: 'useScoringOverrides' });
      }
    })();
    return () => { mounted = false; };
  }, []);
}
